import React from 'react';

export function Review({ url }: { url: string }) {
  return <iframe style={{width: '100vw', height: '100vh', border: 'none'}} src={url}></iframe>;
}
